import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import React, { useState, memo, useEffect } from 'react';
import { Avatar, ErrorBlock, List, Select, Tag } from '@hose/eui';
import EkbHighLighter from '../EkbHighLighter';
import styles from './filter.module.less';
import { app } from '@ekuaibao/whispered';
import { debounce } from 'lodash';
import classnames from 'classnames';
import { filterStaff, getStaffShowByConfig, isConfigShowNickName } from '../utilFn';
import { DropdownRender, Loading, MaxTagPlaceholder } from './columnOthers';
import { getStaffs, setStaffs } from './FilterCache';
import { IllustrationSmallNoSearch, OutlinedTipsDone } from '@hose/eui-icons';
import { useDepartmentVisible } from '../../lib/featbit';
import { StaffItemInWeComISV, queryStaffDataInWeComISV } from './StaffFilter.wecom';
var getPopupContainer = function (node) { return node.parentNode; };
var pageCount = 200;
var filterScope;
var staffDisplayConfig;
export var StaffFilter = memo(function (_a) {
    var value = _a.value, onChange = _a.onChange, onOk = _a.onOk, onReset = _a.onReset, scenesType = _a.scenesType;
    var _b = __read(useState([]), 2), list = _b[0], setList = _b[1];
    var _c = __read(useState(value !== null && value !== void 0 ? value : []), 2), checkedKeys = _c[0], setCheckedKeys = _c[1];
    var _d = __read(useState(''), 2), searchStr = _d[0], setSearchStr = _d[1];
    var _e = __read(useState(false), 2), loading = _e[0], setLoading = _e[1];
    useEffect(function () {
        if (!!(value === null || value === void 0 ? void 0 : value.length)) {
            initList();
        }
    }, []);
    var initList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var staffs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getStaffs(value)];
                case 1:
                    staffs = _a.sent();
                    setList(staffs);
                    return [2];
            }
        });
    }); };
    var fetchData = function (searchKey) { return __awaiter(void 0, void 0, void 0, function () {
        var contactConfig, organizationConfig, params, result, staffs;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!searchKey && !(value === null || value === void 0 ? void 0 : value.length)) {
                        return [2];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 8, 9]);
                    if (!!filterScope) return [3, 3];
                    return [4, app.dataLoader('@contactManagement.contactConfig').load()];
                case 2:
                    contactConfig = _c.sent();
                    filterScope = contactConfig === null || contactConfig === void 0 ? void 0 : contactConfig.filterScope;
                    _c.label = 3;
                case 3:
                    if (!(staffDisplayConfig === undefined)) return [3, 5];
                    return [4, app.dataLoader('@common.organizationConfig').load()];
                case 4:
                    organizationConfig = _c.sent();
                    staffDisplayConfig = ((_a = organizationConfig === null || organizationConfig === void 0 ? void 0 : organizationConfig.staffDisplayConfig) === null || _a === void 0 ? void 0 : _a[1]) || '';
                    _c.label = 5;
                case 5:
                    params = getParams(searchKey, checkedKeys);
                    setLoading(true);
                    return [4, (window.isInWeComISV ? queryStaffDataInWeComISV(searchKey) : app.invokeService('@contacts:search:staffs:list', params))];
                case 6:
                    result = _c.sent();
                    staffs = (_b = result === null || result === void 0 ? void 0 : result.items) !== null && _b !== void 0 ? _b : [];
                    return [4, setStaffs(staffs)];
                case 7:
                    _c.sent();
                    setList(staffs);
                    return [3, 9];
                case 8:
                    setLoading(false);
                    return [7];
                case 9: return [2];
            }
        });
    }); };
    var handleSearch = debounce(function (searchValue) {
        if (searchValue) {
            fetchData(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim());
        }
        setSearchStr(searchValue);
    }, 500);
    var handleChange = function (value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        setCheckedKeys(value);
    };
    var handleConfirm = function () {
        onOk === null || onOk === void 0 ? void 0 : onOk();
    };
    var handleReset = function () {
        setCheckedKeys([]);
        onReset === null || onReset === void 0 ? void 0 : onReset();
    };
    return (React.createElement("div", { className: styles['filter-content-wrapper'] },
        React.createElement(Select, { getPopupContainer: getPopupContainer, placeholder: i18n.get('请输入要搜索的人员'), value: checkedKeys, dropdownRender: function (menu) { return React.createElement("div", { style: { display: 'none' } }, menu); }, mode: "multiple", maxTagPlaceholder: function (omittedValues) { return React.createElement(MaxTagPlaceholder, { omittedValues: omittedValues, titleKey: "title" }); }, onChange: handleChange, onSearch: handleSearch, filterOption: filterOptions, autoFocus: true, optionFilterProp: "children", style: { width: '100%' }, listHeight: 200, allowClear: true, showSearch: true, showArrow: true, virtual: true, open: true, maxTagCount: 2 }, list.map(function (item) {
            if (window.isInWeComISV) {
                return (React.createElement(Select.Option, { key: item.id, value: item.id },
                    React.createElement(StaffItemInWeComISV, { staff: item })));
            }
            var title = getStaffShowByConfig(item);
            var status = getStatus(item);
            var showTitle = !!status ? title + "(" + status + ")" : title;
            return (React.createElement(Select.Option, { key: item.id, value: item.id, title: showTitle, data: item },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center'
                    } },
                    React.createElement(StaffItem, { staff: item }))));
        })),
        React.createElement(DropdownRender, { className: styles['filter-dropdown-render'], originNode: React.createElement(StaffList, { loading: loading, list: list, value: checkedKeys, searchStr: searchStr, onChange: handleChange }), onConfirm: handleConfirm, onReset: handleReset })));
});
var StaffList = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, list = _a.list, loading = _a.loading, searchStr = _a.searchStr, onChange = _a.onChange;
    var handleItemChange = function (item) {
        var checkedData = __spread(value);
        if (checkedData.includes(item.id)) {
            checkedData = checkedData.filter(function (id) { return id !== item.id; });
        }
        else {
            checkedData.push(item.id);
        }
        onChange(checkedData, item);
    };
    return (React.createElement("div", { className: styles['list-wrapper'] }, loading ? (React.createElement(Loading, null)) : searchStr && list.length === 0 ? (React.createElement(EmptyBlock, null)) : (React.createElement(List, { dataSource: list, renderItem: function (item) {
            var _a;
            var title = getStaffShowByConfig(item);
            var selected = value.includes(item === null || item === void 0 ? void 0 : item.id);
            return (React.createElement("div", { className: classnames(styles['list-item'], (_a = {}, _a[styles['list-item-checked']] = selected, _a)), onClick: function () { return handleItemChange(item); }, title: title },
                React.createElement("div", { className: "list-item-content" }, window.isInWeComISV
                    ? React.createElement(StaffItemInWeComISV, { staff: item })
                    : React.createElement(StaffItem, { staff: item, searchKey: searchStr })),
                selected && React.createElement(OutlinedTipsDone, { color: "var(--eui-primary-pri-500)" })));
        } }))));
};
var EmptyBlock = function () {
    var title = filterScope === 'UNLIMITED' ? i18n.get('未匹配到人员，请精确搜索或联系管理员确认可见范围') : i18n.get('暂无数据');
    return (React.createElement(ErrorBlock, { title: title, image: React.createElement(IllustrationSmallNoSearch, null), style: {
            height: '100%',
            margin: '0 40px'
        } }));
};
export var StaffItem = function (_a) {
    var staff = _a.staff, _b = _a.searchKey, searchKey = _b === void 0 ? '' : _b, _c = _a.avatarStyle, avatarStyle = _c === void 0 ? {} : _c;
    var title = getStaffShowByConfig(staff);
    var item = __assign(__assign({}, staff), { label: title });
    return (React.createElement(React.Fragment, null,
        React.createElement(Avatar, { shape: "circle", src: item === null || item === void 0 ? void 0 : item.avatar, size: "small", style: __assign({ marginRight: 4, width: 16, height: 16, lineHeight: '16px', border: '1px solid white', marginBottom: 2 }, avatarStyle) }),
        !!searchKey ? (React.createElement(EkbHighLighter, { highlightClassName: styles['highlight'], searchWords: [searchKey], textToHighlight: title })) : (title),
        React.createElement(StatusTag, { item: staff })));
};
var filterOptions = function (input, option) {
    if (window.isInWeComISV) {
        return true;
    }
    return filterStaff(input, option.data);
};
var getStatus = function (item) {
    var str = '';
    if (!item.active) {
        str = i18n.get('已离职');
    }
    else if (!item.authState && !item.external) {
        str = i18n.get('已停用');
    }
    return str;
};
export var StatusTag = function (_a) {
    var item = _a.item;
    var str = getStatus(item);
    if (!!str) {
        return (React.createElement(Tag, { style: { marginLeft: 4 }, size: "small" }, str));
    }
    return React.createElement(React.Fragment, null);
};
export var getParams = function (searchStr, checkedIds) {
    if (checkedIds === void 0) { checkedIds = []; }
    var query = {
        limit: {
            start: 0,
            count: pageCount
        },
        orderBy: [
            {
                value: 'active',
                order: 'DESC'
            },
            {
                value: 'authState',
                order: 'DESC'
            }
        ]
    };
    var filterBy = '';
    var staffDisplayConfigTags = ['code', 'email', 'cellphone', 'note'];
    if (searchStr) {
        if (useDepartmentVisible() && filterScope === 'UNLIMITED') {
            filterBy = isConfigShowNickName()
                ? "nickName.containsIgnoreCase(\"" + searchStr + "\")"
                : "name==(\"" + searchStr + "\")||enName==(\"" + searchStr + "\")";
            if (staffDisplayConfig && staffDisplayConfigTags.includes(staffDisplayConfig))
                filterBy += "||" + staffDisplayConfig + "==(\"" + searchStr + "\")";
        }
        else {
            var lowerStr = searchStr.toLowerCase();
            filterBy = isConfigShowNickName()
                ? "nickName.containsIgnoreCase(\"" + lowerStr + "\")"
                : "lower(name).containsIgnoreCase(\"" + lowerStr + "\")||nickName.containsIgnoreCase(\"" + lowerStr + "\")||lower(nameSpell).containsIgnoreCase(\"" + lowerStr + "\")||lower(nameInitial).containsIgnoreCase(\"" + lowerStr + "\")||lower(enName).containsIgnoreCase(\"" + lowerStr + "\")";
            if (staffDisplayConfig && staffDisplayConfigTags.includes(staffDisplayConfig))
                filterBy += "||lower(" + staffDisplayConfig + ").containsIgnoreCase(\"" + lowerStr + "\")";
        }
    }
    if (checkedIds.length) {
        var ids = checkedIds.map(function (item) { return "\"" + item + "\""; });
        filterBy = (!!filterBy ? filterBy + "||" : '') + "id.in(" + ids.join(',') + ")";
    }
    if (!!filterBy) {
        query.filterBy = filterBy;
    }
    var res = {
        query: query,
        searchAll: true
    };
    if (useDepartmentVisible()) {
        res.visible = filterScope !== 'UNLIMITED';
    }
    return res;
};
export default StaffFilter;
